import api from '@/utils/axios';

export default {
  namespaced: true,
  state: {
    user: {
      isLogged: false,
      name: null,
      email: null,
      status: null,
      id: null
    },
    isValidating: false,
    selectedUser: null,
    pagination: {
      page: 1,
      limit: 10,
      first: 0
    },
    search: {
      query: ''
    }
  },
  getters: {
    isUserEmail: (state) => {
      return state.user.email;
    },
    usersPagination: (state) => state.pagination,
    usersSearch: (state) => state.search
  },
  mutations: {
    loginUser(state, payload) {
      state.user.isLogged = true;
      state.user.token = payload.jwt;
      state.user.name = payload.name;
      state.user.email = payload.email;
      state.user.status = payload.status;
      state.user.id = payload.id;

      try {
        localStorage.setItem('ahToken', payload.jwt || '');
        localStorage.setItem('ahEmail', payload.email || '');
        localStorage.setItem('ahName', payload.name || '');
        localStorage.setItem('ahStatus', payload.status || '');
        localStorage.setItem('ahId', payload.id || '');
        localStorage.setItem('ahIsLogged', 'true');
      } catch (e) {
        // Error saving user data to localStorage
      }
    },
    validateUser(state, payload) {
      try {
        state.user.isLogged = true;
        state.user.token = payload.jwt || localStorage.getItem('ahToken') || null;
        state.user.name = payload.name || localStorage.getItem('ahName') || null;
        state.user.email = payload.email || localStorage.getItem('ahEmail') || null;
        state.user.status = payload.status || localStorage.getItem('ahStatus') || null;
        state.user.id = payload.id || localStorage.getItem('ahId') || null;
      } catch (e) {
        state.user.token = payload.jwt || null;
        state.user.name = payload.name || null;
        state.user.email = payload.email || null;
        state.user.status = payload.status || null;
        state.user.id = payload.id || null;
      }
    },
    setValidating(state, isValidating) {
      state.isValidating = isValidating;
    },
    logoutUser(state) {
      state.user.isLogged = false;
      state.user.token = null;
      state.user.name = null;
      state.user.email = null;
      state.user.status = null;
      state.user.id = null;

      localStorage.removeItem('ahToken');
      localStorage.removeItem('ahEmail');
      localStorage.removeItem('ahName');
      localStorage.removeItem('ahStatus');
      localStorage.removeItem('ahId');
      localStorage.removeItem('ahIsLogged');
    },
    clearUserData(state) {
      state.user.isLogged = false;
      state.user.token = null;
      state.user.name = null;
      state.user.email = null;
      state.user.status = null;
      state.user.id = null;
    },
    setSelectedUser(state, user) {
      state.selectedUser = user;
    },
    setUsersPagination(state, payload) {
      state.pagination = {
        page: payload.page,
        limit: payload.limit,
        first: payload.first
      };
    },
    setUsersSearch(state, payload) {
      state.search = {
        query: payload.query
      };
    }
  },
  actions: {
    loginUser({ commit }, payload) {
      commit("loginUser", payload);
    },
    async initializeAuth({ commit, state }) {
      if (state.isValidating) {
        return;
      }

      try {
        commit("setValidating", true);

        const token = localStorage.getItem("ahToken");
        const isLogged = localStorage.getItem("ahIsLogged");

        if (token && isLogged === 'true') {
          const payload = {
            jwt: token,
            email: localStorage.getItem("ahEmail"),
            name: localStorage.getItem("ahName"),
            status: localStorage.getItem("ahStatus"),
            id: localStorage.getItem("ahId")
          };

          commit("validateUser", payload);

          try {
            const response = await api.post('/users/validate', { token });

            if (response.data && response.data.success) {
              commit("validateUser", response.data.data || {});
            } else {
              commit("logoutUser");
            }
          } catch (error) {
            // Keep user authorized with data from localStorage on network error
          }
        } else {
          commit("clearUserData");
        }
      } catch (e) {
        commit("clearUserData");
      } finally {
        commit("setValidating", false);
      }
    },
    updateUsersPagination({ commit }, pagination) {
      commit('setUsersPagination', pagination);
    },
    updateUsersSearch({ commit }, search) {
      commit('setUsersSearch', search);
    }
  },
  modules: {},
};
